import { css, Theme } from '@emotion/react'

export const itemLogsTable = (theme: Theme) => css`
  border: 1px solid ${theme.colors.backgroundOne};
  border-radius: 20px;
  row-gap: 0px;

  .table-row {
    border: none;
    box-shadow: none;
    padding: ${theme.spacing(1.75, 2)};
    border-radius: 0;
    min-height: 60px;

    &:nth-of-type(2n + 2) {
      background: ${theme.colors.backgroundFive};
    }

    &:first-of-type {
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
    }

    &:last-of-type {
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;
    }
  }

  .table-cell {
    color: ${theme.colors.typographyThree};

    line-height: 28px;
  }
`

export const secondaryTitle = css`
  font-size: 18px;
  font-weight: 600;
`

export const itemsTableWrapper = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(1.5)};
  border: 1px solid ${theme.colors.backgroundOne};
  border-radius: 16px;
  padding: ${theme.spacing(1)};
`

export const itemsTable = (theme: Theme) => css`
  row-gap: 5px;

  .table-header {
    min-height: 48px;

    .table-cell {
      color: ${theme.colors.typographyTwo};
      font-size: 14px;
      font-weight: 500;
    }
  }

  .table-row {
    border: none;
    box-shadow: none;
    padding: ${theme.spacing(0.75, 2)};
    border-radius: 14px;
    min-height: 48px;

    &:nth-of-type(2n + 1) {
      background: ${theme.colors.backgroundFive};
    }

    &:first-of-type {
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
    }

    &:last-of-type {
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;
    }
  }

  .table-cell {
    color: ${theme.colors.typographyThree};
    font-size: 14px;
  }
`

export const rowEditButton = (theme: Theme) => css`
  border-radius: 10px;
  border: 1px solid ${theme.colors.backgroundOne};

  background-color: ${theme.colors.white};
`

export const editModalForm = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing(2.75)};

  width: 100%;
`

export const editModalFormTitle = css`
  font-size: 24px;
  font-weight: 700;
  text-align: center;
`

export const editModalFields = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing(1.75)};
`

export const editModalActions = (theme: Theme) => css`
  display: flex;
  column-gap: ${theme.spacing(1.25)};
`

export const platformTabs = (theme: Theme) => css`
  flex-wrap: wrap;

  > p:not([data-active='true']) {
    color: ${theme.colors.typographyThree};
  }
`

export const loader = (theme: Theme) => css`
  padding: ${theme.spacing(2)};
`

export const noItemsFound = (theme: Theme) => css`
  color: ${theme.colors.typographyThree};
  padding: ${theme.spacing(2)};
`
